import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { AppConsts } from './shared/AppConsts';
import { HttpClient } from '@angular/common/http';
import { tap, take } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AppSessionService } from '@axilla/axilla-shared';
import { environment } from './environments/environment';

@Component({
    selector: 'app-root',
    template: `<router-outlet></router-outlet><ngx-spinner type="ball-clip-rotate" size="medium" color="#5ba7ea"></ngx-spinner>`,
    encapsulation: ViewEncapsulation.None
})
export class RootComponent implements OnInit {
    constructor(
        private http: HttpClient,
        router: Router,
        private _sessionService: AppSessionService
    ) {
        const portalUrl = environment.baseUrlHost;

        if (location.pathname === '/') {
            router.navigate(['/global']);
        } else if (location.pathname.includes('account')) {

            if (location.search) {
                router.navigate([location.pathname], { queryParams: this._parseSearch() });
            } else {
                router.navigate([location.pathname]);
            }

        } else if (location.hostname.includes(portalUrl)) {
            if (!this._sessionService.user) {
                if (location.pathname === '/marriott') {
                    router.navigate([location.pathname]);
                } else {
                    router.navigate(['/global']);
                }
            }
        }
    }

    css$ = this.http.get(this.getPath('/TenantCustomization/GetSpriteCss'), { responseType: 'text' });

    getPath(postfix: string): string {
        return AppConsts.remoteServiceBaseUrl + postfix;
    }


    private _parseSearch(): any {
        let queryParams = {};

        let searchString = location.search;
        if (searchString) {
            let searchString = location.search.slice(1);

            let splittedParams = searchString.split('&');
            for (let i = 0; i < splittedParams.length; i++) {
                let item = splittedParams[i];
                let splittedItem = item.split('=');

                queryParams[splittedItem[0]] = splittedItem[1];
            }

        }

        return queryParams;
    }

    ngOnInit(): void {
        this.css$.pipe(
            take(1),
            tap((css) => {
                const style = document.createElement('style');
                css = css.replace('/Content/Sprite/SpriteVar.png', this.getPath('/TenantCustomization/GetSpritePng'));
                style.textContent = css;
                const head = document.getElementsByTagName('head')[0];
                head.appendChild(style);
            })
        ).subscribe();
    }
}


@Component({
    selector: 'app-global',
    template: `<ngx-spinner type="ball-clip-rotate" size="medium" color="#5ba7ea"></ngx-spinner>`,
})
export class GlobalComponent implements OnInit {
    constructor() {
    }

    ngOnInit(): void {
    }
}
